import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";

const BASE_URL = "/api/comments";

export const fetchDiscussion = createAsyncThunk(
  "comments/fetchDiscussion",
  async ({ surface, containerId, itemRef }) => {
    const { data } = await localhost.get(BASE_URL, {
      params: { surface, containerId, ...itemRef },
    });
    return data;
  }
);

export const fetchCounts = createAsyncThunk(
  "comments/fetchCounts",
  async ({ surface, containerId }) => {
    const { data } = await localhost.get(`${BASE_URL}/counts`, {
      params: { surface, containerId },
    });
    return data;
  }
);

export const fetchOutlineCounts = createAsyncThunk(
  "comments/fetchOutlineCounts",
  async ({ outlineId }) => {
    const { data } = await localhost.get(`${BASE_URL}/counts/outline`, {
      params: { outlineId },
    });
    return data;
  }
);

export const postComment = createAsyncThunk(
  "comments/postComment",
  async ({ surface, containerId, itemRef, parentCommentId = null, body }) => {
    const { data } = await localhost.post(BASE_URL, {
      surface,
      containerId,
      itemRef,
      parentCommentId,
      body,
    });
    return data;
  }
);

export const editComment = createAsyncThunk(
  "comments/editComment",
  async ({ commentId, body }) => {
    const { data } = await localhost.put(`${BASE_URL}/${commentId}`, {
      body,
    });
    return data;
  }
);

export const deleteComment = createAsyncThunk(
  "comments/deleteComment",
  async ({ commentId }) => {
    const { data } = await localhost.delete(`${BASE_URL}/${commentId}`);
    return data;
  }
);

export const postBulkComment = createAsyncThunk(
  "comments/postBulkComment",
  async ({ surface, containerId, itemRefs, body }) => {
    const { data } = await localhost.post(`${BASE_URL}/bulk`, {
      surface,
      containerId,
      itemRefs,
      body,
    });
    return data;
  }
);

export const fetchMentionCandidates = createAsyncThunk(
  "comments/fetchMentionCandidates",
  async ({ q }) => {
    const { data } = await localhost.get(`${BASE_URL}/mention-candidates`, {
      params: { q },
    });
    return data.candidates;
  },
  {
    condition: ({ q } = {}) => typeof q === "string",
  }
);
